import { render, staticRenderFns } from "./baDefault.vue?vue&type=template&id=4ef03830&scoped=true"
import script from "./baDefault.vue?vue&type=script&lang=js"
export * from "./baDefault.vue?vue&type=script&lang=js"
import style0 from "./baDefault.vue?vue&type=style&index=0&id=4ef03830&prod&scoped=true&lang=scss"
import style1 from "./baDefault.vue?vue&type=style&index=1&id=4ef03830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef03830",
  null
  
)

export default component.exports